import classNames from 'classnames';
import * as React from 'react';
import { LinkButton } from '../../../Common/LinkButton';
import './style.css';

export interface LoginRequiredSectionProps
  extends React.ComponentPropsWithoutRef<'section'> {
  /* empty*/
}

export interface LoginRequiredSectionState {
  /* empty*/
}

export class LoginRequiredSection extends React.Component<
  LoginRequiredSectionProps,
  LoginRequiredSectionState
> {
  render() {
    const { props } = this;

    return (
      <section
        {...props}
        className={classNames(
          'premium-login-required-section',
          props.className
        )}
      >
        <div className="premium-login-required-section__inner">
          <h2 className="premium-login-required-section__heading">
            Login Required
          </h2>
          <p className="premium-login-required-section__content">
            Subscription to our content requires an Edge of Play account.
            <br />
            <br />
            In order to sign up for Edge of Play membership please
          </p>
          <div className="premium-login-required-section__links">
            {this.getLoginLink()}
            <span className="premium-login-required-section__links-separator">
              or
            </span>
            {this.getRegisterLink()}
          </div>
        </div>
      </section>
    );
  }

  private getLoginLink = () => {
    return (
      <LinkButton
        className="premium-login-required-section__login-link"
        to={'/login'}
      >
        Log in
      </LinkButton>
    );
  };

  private getRegisterLink = () => {
    return (
      <LinkButton
        className="premium-login-required-section__register-link"
        to={'/sign-up'}
      >
        Sign up
      </LinkButton>
    );
  };
}

export default LoginRequiredSection;



// WEBPACK FOOTER //
// ./src/app/components/Premium/PremiumPage/LoginRequiredSection/index.tsx